export default __webpack_public_path__ + "static/media/cart-icon.5430336c.svg";